import { ROADMAP_PHASES } from "@/data/content";
import PageHero from "@/components/arc/PageHero";
import Reveal from "@/components/arc/Reveal";
import { GlowButton, Panel, StatusBadge } from "@/components/arc/ui";
import { GlowOrbs } from "@/components/arc/Backdrops";

const Roadmap = () => (
  <>
    <PageHero
      index="08"
      eyebrow="PRIME DIRECTIVE"
      title="THE PRIME DIRECTIVE"
      sub="The long-range plan for the machine economy. Phases describe direction, not guarantees — everything future-facing is labelled."
    />
    <section className="relative overflow-hidden pb-24 md:pb-36">
      <GlowOrbs />
      <div className="relative mx-auto max-w-5xl px-5 md:px-8" data-testid="roadmap-timeline">
        <div className="absolute bottom-0 left-[19px] top-0 w-px bg-gradient-to-b from-electric via-arc/40 to-transparent md:left-1/2" aria-hidden="true" />
        {ROADMAP_PHASES.map((phase, i) => {
          const left = i % 2 === 0;
          return (
            <Reveal key={phase.id} delay={0.05}>
              <div
                className={`relative flex pb-14 md:w-1/2 ${
                  left ? "md:pr-14" : "md:ml-auto md:pl-14"
                } pl-14 md:pl-0 ${left ? "" : "md:pl-14"}`}
                data-testid={`roadmap-phase-${phase.id}`}
              >
                <span
                  className={`absolute top-2 flex h-10 w-10 items-center justify-center rounded-full border border-electric/60 bg-abyss font-term text-[10px] tracking-widest text-electric shadow-[0_0_20px_rgba(0,168,255,0.5)] ${
                    left
                      ? "-left-[1px] md:left-auto md:-right-5"
                      : "-left-[1px] md:-left-5"
                  }`}
                  aria-hidden="true"
                >
                  {phase.id}
                </span>
                <Panel className="w-full p-7 md:p-8">
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <span className="font-term text-[10px] tracking-[0.34em] text-silver">
                      PHASE {phase.id}
                    </span>
                    <StatusBadge status={phase.state} />
                  </div>
                  <h2 className="mt-4 font-display text-xl font-black tracking-[0.14em] text-chrome md:text-2xl">
                    {phase.title}
                  </h2>
                  <p className="mt-4 text-sm leading-relaxed text-silver">{phase.body}</p>
                  <ul className="mt-6 space-y-2 border-t border-ice/10 pt-5">
                    {phase.items.map((item) => (
                      <li key={item} className="flex items-center gap-3 font-term text-[11px] tracking-[0.18em] text-ice/85">
                        <span className="h-1 w-1 rotate-45 bg-electric" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </Panel>
              </div>
            </Reveal>
          );
        })}
      </div>
      <div className="mx-auto mt-6 max-w-5xl px-5 md:px-8">
        <Reveal>
          <div className="flex flex-col items-center gap-6 border-t border-ice/10 pt-14 text-center">
            <p className="max-w-xl text-base leading-relaxed text-silver">
              Nothing on this timeline is a promise. Phase states — ACTIVE, PLANNED, EXPLORATION,
              CONCEPT, VISION — describe exactly how real each stage is.
            </p>
            <GlowButton to="/missions" testId="roadmap-missions-btn">OPEN MISSION CONTROL</GlowButton>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Roadmap;
